import { JSX } from 'react'

import { IconProps } from '../../icon'

const VideoPlayer: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 33 32'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_1191_26)'>
      <path
        d='M16.5 32C25.3366 32 32.5 24.8366 32.5 16C32.5 7.16344 25.3366 0 16.5 0C7.66344 0 0.5 7.16344 0.5 16C0.5 24.8366 7.66344 32 16.5 32Z'
        fill='#E10719'
      />
      <path
        d='M23.3656 15.2196L13.0737 9.60588C12.4814 9.28281 11.7592 9.7115 11.7592 10.3863V21.6138C11.7592 22.2885 12.4814 22.7172 13.0737 22.3941L23.3656 16.7804C23.9833 16.4434 23.9833 15.5566 23.3656 15.2196Z'
        fill='white'
      />
      <path
        d='M20.6493 3.7543C20.5747 3.7543 20.4989 3.74274 20.4242 3.71899C20.0551 3.60134 19.6809 3.50034 19.3027 3.4163C18.9034 3.32749 18.6516 2.93193 18.7407 2.5323C18.8287 2.13299 19.2216 1.87924 19.6244 1.97012C20.0459 2.06387 20.463 2.17644 20.8744 2.30749C21.2639 2.43193 21.4792 2.84855 21.3547 3.23837C21.2546 3.55324 20.9629 3.7543 20.6493 3.7543ZM28.2761 9.87324C28.1466 9.87338 28.0194 9.83958 27.9071 9.77521C27.7948 9.71083 27.7013 9.61814 27.636 9.50637C26.5087 7.57787 24.8924 5.96587 22.9606 4.84462C22.6071 4.63918 22.4867 4.18574 22.6921 3.83218C22.8981 3.4783 23.3496 3.35705 23.7049 3.56337C25.8571 4.81305 27.6586 6.60968 28.9149 8.75868C29.1216 9.11199 29.0023 9.56568 28.6493 9.77199C28.5362 9.83846 28.4073 9.87342 28.2761 9.87324Z'
        fill='#FF4554'
      />
      <path
        d='M19.3007 27.7966C11.5836 27.1639 5.3362 20.9165 4.70351 13.1994C4.57864 11.6761 4.66776 10.1934 4.94382 8.77743C5.20351 7.44543 3.37182 6.75449 2.68558 7.92524C1.10126 10.6282 0.287825 13.8376 0.547763 17.2524C1.1407 25.043 7.45707 31.3593 15.2476 31.9522C18.6624 32.2122 21.8718 31.3987 24.5748 29.8144C25.7456 29.1282 25.0546 27.2965 23.7226 27.5562C22.3067 27.8323 20.8239 27.9214 19.3007 27.7966Z'
        fill='#C90314'
      />
      <path
        d='M14.1049 17.2999V10.1683L13.0738 9.60588C12.4815 9.28281 11.7593 9.7115 11.7593 10.3863V21.6138C11.7593 22.2884 12.4815 22.7172 13.0738 22.3941L23.3657 16.7803C23.6756 16.6112 23.8297 16.3037 23.8285 15.9966L15.6281 18.4359C14.8682 18.6619 14.1049 18.0926 14.1049 17.2999Z'
        fill='#E4EAF8'
      />
    </g>
    <defs>
      <clipPath id='clip0_1191_26'>
        <rect width='32' height='32' fill='white' transform='translate(0.5)' />
      </clipPath>
    </defs>
  </svg>
)

export default VideoPlayer
